import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { QUOTE_ERRORS } from "src/constants";
import { SAGA_GUARDS } from "src/navigation";
import { shoot } from "src/redux/actions";
import { select_loading, select_quote, select_error, select_history_item } from "src/redux/store";
import { formik_value_t, coverage_t, agency_product_t, coverages_t } from "src/types";
import { Formik, FormikDataEntryValues } from "src/types/formik";
import { quote_t } from "src/types/http/quote.types";
import { get_language } from "src/utils";
import { get_quote_data } from "../../handlers/data-entry-quote";

export const useDataEntryStep3 = (formik: Formik<FormikDataEntryValues>) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { values } = formik;

  /**
   * UseState
   */
  const [items, set_items] = useState<formik_value_t>();
  const [language] = useState(get_language().toLocaleLowerCase());
  const [coverage, set_coverage] = useState<coverage_t>();
  const [error_discount, set_error_discount] = useState("");
  const [first_time_discount, set_first_time_discount] = useState(false);

  /**
   * UseSelector
   */
  const loading = useSelector(select_loading(SAGA_GUARDS.QUOTE));
  const quote = useSelector(select_quote);
  const error = useSelector(select_error());

  const agency: agency_product_t = useSelector(
    select_history_item("history_agency")
  );
  const products = useSelector(select_history_item("history_products"));

  const coverages: coverages_t = useSelector(
    select_history_item("history_coverages")
  );

  useEffect(() => {
    const products_: formik_value_t = JSON.parse(products);
    const data_: quote_t = get_quote_data(
      products_ || {},
      agency,
      "",
      quote?.quoteId
    );
    dispatch(shoot.saga_quote(data_));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (error && QUOTE_ERRORS.includes(error?.code || "")) {
      set_error_discount(error?.description_fe || "");
    }
  }, [error]);

  useEffect(() => {
    if (items?.discount === "" && quote?.discount && first_time_discount) {
      set_error_discount("");
      dispatch(shoot.reduce_error());
      const data_: quote_t = get_quote_data(
        values || {},
        agency,
        "",
        quote?.quoteId
      );
      dispatch(shoot.saga_quote(data_));
    }

    if (items?.discount === "" && error_discount) {
      set_error_discount("");
      dispatch(shoot.reduce_error());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items?.discount, first_time_discount]);

  useEffect(() => {
    if (values) {
      set_items({ ...values });
      set_coverage(coverages[values?.coverage_type_radios || ""]);
      if (values?.discount && values?.discount !== "") {
        set_first_time_discount(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  const uppercase_discount_value = (props: any) => {
    let _props = props;
    _props["value"] = props["value"].toString().toUpperCase();
    return _props;
  };

  const update_total_quote = () => {
    const data_: quote_t = get_quote_data(
      values || {},
      agency,
      "",
      quote?.quoteId
    );
    set_error_discount("");
    dispatch(shoot.reduce_error());
    dispatch(shoot.saga_quote(data_));
  };


  return {
    t,
    items,
    coverage,
    coverages,
    language,
    loading,
    agency,
    error_discount,
    quote,
    uppercase_discount_value,
    update_total_quote
  }

}